import angular from 'angular';

import {downgradeComponent, downgradeInjectable} from "@angular/upgrade/static";
import {
    AppLoaderService,
} from "../src/app/core/services/app-loader.service";
import {
    SectionLoaderService,
} from "../src/app/core/services/section-loader.service";
import {
    SectionLoaderComponent,
} from "../src/app/core/components/section-loader/section-loader.component";
import {SkeletonPageComponent} from "../src/app/core/components/skeleton-loaders";
import {
    NewMaterialSidenavComponent
} from "../src/app/core/components/new-material-sidenav/new-material-sidenav.component";
import {
    SettingsUsersManagementComponent,
    CustomersDetailsComponent,
    CustomersShowcaseComponent,
    DashboardComponent,
    GiftcardShowcaseComponent,
    GiftcardTypesPanelComponent,
    HistorySalesShowcaseComponent,
    HistoryCashMovementsComponent,
    SettingsModelDocumentComponent,
    SettingsLabelPanelComponent,
    SettingsShiftsComponent,
    SettingsChannelsComponent,
    SettingsTicketsComponent,
    SettingsUserComponent,
    SuppliersDetailsComponent,
    SuppliersShowcaseComponent,
    TablesComponent,
    CashregisterComponent,
    CashregisterShowcaseComponent,
    ActiveSaleComponent,
    PromotionEngineService,
    PromotionsShowcaseComponent,
    PromotionsDetailsComponent,
    SettingsAlvoloComponent,
    ActiveSaleService,
    SaleTransactionUtilsService,
    FileImporterComponent,
    ActiveSaleStoreService,
    SalePrintingUtilsService,
    SettingsKioskComponent,
    SaleBatchPrintService,
    BookingsComponent,
    CustomerUtilsService,
    DeliveryTakeAwayComponent,
    HistoryProductsDeletedComponent,
    HistorySalesService,
    PrinterUtilsService,
    DocumentBuilderService,
    StockManagementComponent,
    DashboardReportGeneratorService,
    StockMovementsComponent,
    StockNewMovementComponent
} from "../src/app/features";

import {DualService} from '../src/app/dual.service';
import {
    DocumentPrintersManagerDialogStateService,
    EInvoiceDialogService,
    OpenDialogsService,
    ItemLabelsDialogService,
    EditShopPreferenceDialogService,
    PrinterErrorFiscalDialogService,
    SaleDocumentsViewerDialogService,
    LeanPmsPaymentsDialogService,
    SignupFormDialogService,
    UserSessionsManagerDialogService,
    PromptDialogService,
    AddSelectCustomerDialogService,
    GenericListDialogService,
    NonFiscalPreviewDialogService,
    DailyClosingDialogService,
    AddEditPaymentConditionDialogService,
    ConfirmDialogService,
    AlertDialogService
} from "../src/app/dialogs";

import { RoomsStateService } from 'src/app/features/tables/rooms.state.service';
import { CustomersCallService } from 'src/app/core/services/customers-call.service';
import {
    AppToAppService,
    BarcodeManagerService,
    ConnectionService,
    ConfigurationManagerService,
    EnvironmentInfoService,
    EntityDictionariesStoreService,
    EntityManagerService,
    ScreenOrientationService,
    OauthService,
    StorageManagerService,
    ShopSessionEntity,
    UserSessionsEntity,
    CoreStateService,
    StartupWatchdogService,
    SidenavMenuComponent,
    LoginViewService,
    StartupQueriesService,
    UserActiveSessionManagerService,
    ProgressivesManagerService,
    OperatorManagerService,
    SystemUtilsService,
    ErrorsLoggerService,
    UpdateManagerService,
    BillingDataService,
} from 'src/app/core';

import {
    SaleUtilsService,
    SalePaymentService,
    ActiveSalePaymentService,
} from 'src/app/features/cashregister/services';

import { CashregisterPaymentsComponent } from 'src/app/features/cashregister/components/cashregister-payments/cashregister-payments.component';
import { FileImporterAddComponent } from 'src/app/features/settings/settings-file-importer/components/settings-file-importer-add/settings-file-importer-add.component';
import { FileImporterFieldsComponent } from 'src/app/features/settings/settings-file-importer/components/settings-file-importer-fields/settings-file-importer-fields.component';
import { FileImporterScheduleComponent } from 'src/app/features/settings/settings-file-importer/components/settings-file-importer-schedule/settings-file-importer-schedule.component';
import { CampgestPmsPaymentsDialogService } from 'src/app/dialogs/cashregister/campgest-pms-payments-dialog';
import { CampgestPmsApiService } from 'src/app/shared/services/digital-payments/campgest/campgest-pms-api.service';
import { SettingsFileExporterShowcaseComponent } from 'src/app/features/settings/settings-file-exporter/components/settings-file-exporter-showcase/settings-file-exporter-showcase.component';
import { WellbyPmsPaymentsDialogService } from 'src/app/dialogs/cashregister/wellby-pms-payments-dialog/wellby-pms-payments-dialog.component';
import { WellbyPmsApiService } from 'src/app/shared/services/digital-payments/wellby/wellby-pms-api.service';
import { HistoryUtilsService } from 'src/app/features/history/history-sales/services/history-utils.service';
import { AutomateItemsDialogService } from 'src/app/dialogs/automate-items-dialog/automate-items-dialog.component';
import { EInvoiceCredentialsDialogService } from 'src/app/dialogs/e-invoice-credentials-dialog/e-invoice-credentials-dialog.component'

import {
    AdyenService,
    BeddyApiService,
    BedzzleApiService,
    BedzzleCommonService,
    EricsoftPMSApiService,
    GloryCashdrawerService,
    LeanPMSApiService,
    SatispayService,
    SpiaggeItApiService,
    ZPayBridgeService,
    ZPMSConnectorService,
    ZPaySoftPOSService,
    ZPayService
} from 'src/app/features/digital-payments';

import {
    BookingsStateService
} from 'src/app/features/bookings/services/bookings.state.service';
import { ItemsShowcaseComponent } from 'src/app/features/items/components/items-module/items-tab/items-showcase/items-showcase.component';
import { ItemsModuleComponent } from 'src/app/features/items/components/items-module/items-module.component';
import { ItemDetailsComponent } from 'src/app/features/items/components/items-module/items-tab/item-details/item-details.component';
import { CategoryDetailsComponent } from 'src/app/features/items/components/items-module/categories-tab/category-details/category-details.component';
import { ComponentDetailsComponent } from 'src/app/features/items/components/items-module/components-tab/component-details/component-details.component';
import { RawMaterialDetailsComponent } from 'src/app/features/items/components/items-module/raw-materials-tab/raw-material-details/raw-material-details.component';
import { DepartmentDetailsComponent } from 'src/app/features/items/components/items-module/departments-tab/department-details/department-details.component';
import { VatRateDetailsComponent } from 'src/app/features/items/components/items-module/vat-rates-tab/vat-rate-details/vat-rate-details.component';
import { HistoryModuleComponent } from 'src/app/features/history/history-module/history-module.component';
import { DitronDriverService } from 'src/app/features/printers/drivers/fiscal/ditron/ditron-driver.service';
import { FidelityModuleComponent } from 'src/app/features/fidelity/components/fidelity-module/fidelity-module.component';
import { SettingsPrintersModuleComponent } from 'src/app/features/settings/settings-printers/components/settings-printers-module/settings-printers-module.component';
import { SettingsHubComponent } from 'src/app/features/settings/settings-hub';
import { GeneralSettingsComponent } from 'src/app/features/settings/settings-printers/components/general-settings/general-settings.component';
import { PrinterDetailsComponent } from 'src/app/features/settings/settings-printers/components/printer-details/printer-details.component';
import { NewPrinterComponent } from 'src/app/features/settings/settings-printers/components/new-printer/new-printer.component';
import { ShowTilbyMessagesDialogService } from 'src/app/dialogs/show-tilby-messages-dialog/show-tilby-messages-dialog.component';

angular.module("TilbyApp")
    .factory("dual", downgradeInjectable(DualService))
    .factory("appLoader", downgradeInjectable(AppLoaderService))
    .factory("sectionLoader", downgradeInjectable(SectionLoaderService))
    .factory("billingDataService", downgradeInjectable(BillingDataService))
    .factory("userActiveSession", downgradeInjectable(UserActiveSessionManagerService))
    .factory("openDialogsService", downgradeInjectable(OpenDialogsService))
    .factory("customersCallService", downgradeInjectable(CustomersCallService))
    .factory("activeSaleStore", downgradeInjectable(ActiveSaleStoreService))
    .directive("appSectionLoader", downgradeComponent({component: SectionLoaderComponent}))
    .directive("skeletonPage", downgradeComponent({component: SkeletonPageComponent}))
    .directive("newSidenav", downgradeComponent({component: NewMaterialSidenavComponent}))
    .directive("newSidenavMenuComponent", downgradeComponent({component: SidenavMenuComponent,outputs: ['goTo', 'closeMenuSidenav']}))

angular.module("suppliersNew")
    .directive("suppliersShowcase", downgradeComponent({component: SuppliersShowcaseComponent}))
    .directive("suppliersDetails", downgradeComponent({component: SuppliersDetailsComponent}));

angular.module("stockNew")
    .directive("stockManagement", downgradeComponent({component: StockManagementComponent}))
    .directive("stockMovements", downgradeComponent({component: StockMovementsComponent}))
    .directive("stockNewMovement", downgradeComponent({component: StockNewMovementComponent}))

angular.module("cashregister")
    .factory("documentPrintersManager", downgradeInjectable(DocumentPrintersManagerDialogStateService))
    .factory("eInvoiceDialog", downgradeInjectable(EInvoiceDialogService))
    .factory("promotionEngine", downgradeInjectable(PromotionEngineService))
    .factory("saleUtils", downgradeInjectable(SaleUtilsService))
    .factory("ActiveSale", downgradeInjectable(ActiveSaleService))
    .factory("salePayment", downgradeInjectable(SalePaymentService))
    .factory('activeSalePayment', downgradeInjectable(ActiveSalePaymentService))
    .factory("saleTransactionUtils", downgradeInjectable(SaleTransactionUtilsService))
    .factory("salePrintingUtils", downgradeInjectable(SalePrintingUtilsService))
    .factory("campgestPmsPaymentsDialog", downgradeInjectable(CampgestPmsPaymentsDialogService))
    .factory("campgestPmsApiService", downgradeInjectable(CampgestPmsApiService))
    .factory("wellbyPmsPaymentsDialog", downgradeInjectable(WellbyPmsPaymentsDialogService))
    .factory("wellbyPmsApiService", downgradeInjectable(WellbyPmsApiService))
    .factory("saleBatchPrint", downgradeInjectable(SaleBatchPrintService))
    .directive("cashregisterNewComponent", downgradeComponent({component: CashregisterComponent}))
    .directive("activeSaleComponent", downgradeComponent({component: ActiveSaleComponent}))
    .directive("cashregisterShowcaseComponent", downgradeComponent({component: CashregisterShowcaseComponent}))
    .directive("cashregisterPaymentsComponent", downgradeComponent({component: CashregisterPaymentsComponent}))

angular.module("fileImporter")
    .directive("appFileImporter", downgradeComponent({component: FileImporterComponent}))
    .directive("appFileImporterAdd", downgradeComponent({component: FileImporterAddComponent}))
    .directive("appFileImporterFields", downgradeComponent({component: FileImporterFieldsComponent}))
    .directive("appFileImporterSchedule", downgradeComponent({component: FileImporterScheduleComponent}))

angular.module("fileExporter")
    .directive("appFileExporter", downgradeComponent({component: SettingsFileExporterShowcaseComponent}))

angular.module("customers")
    .directive("customersShowcase", downgradeComponent({component: CustomersShowcaseComponent}))
    .directive("customersDetails", downgradeComponent({component: CustomersDetailsComponent}))
    .service("customerUtils", downgradeInjectable(CustomerUtilsService))

angular.module("itemsNew")
    .directive("itemsShowcase", downgradeComponent({component: ItemsShowcaseComponent}))
    .directive("itemsModule", downgradeComponent({component: ItemsModuleComponent}))
    .directive("itemDetails", downgradeComponent({component: ItemDetailsComponent}))
    .directive("categoryDetails", downgradeComponent({component: CategoryDetailsComponent}))
    .directive("componentDetails", downgradeComponent({component: ComponentDetailsComponent}))
    .directive("rawMaterialDetails", downgradeComponent({component: RawMaterialDetailsComponent}))
    .directive("departmentDetails", downgradeComponent({component: DepartmentDetailsComponent}))
    .directive("vatRateDetails", downgradeComponent({component: VatRateDetailsComponent}))

angular.module("history")
    .directive("historyModule", downgradeComponent({component: HistoryModuleComponent}))
    .directive("historySalesShowcase", downgradeComponent({component: HistorySalesShowcaseComponent}))
    .directive("historyCashMovements", downgradeComponent({component: HistoryCashMovementsComponent}))
    .directive("historyProductsDeleted", downgradeComponent({component: HistoryProductsDeletedComponent}))
    .service("saleDocumentsViewer", downgradeInjectable(SaleDocumentsViewerDialogService))
    .service("HistoryUtils", downgradeInjectable(HistoryUtilsService))
    .service("HistorySalesService", downgradeInjectable(HistorySalesService))

angular.module("fidelityNew")
    .directive("fidelityModule", downgradeComponent({component: FidelityModuleComponent}))

angular.module("giftcard")
    .directive("giftcardShowcase", downgradeComponent({component: GiftcardShowcaseComponent}))
    .directive("giftcardTypesPanel", downgradeComponent({component: GiftcardTypesPanelComponent}))

angular.module("bookings")
    .directive("bookingsShowcase", downgradeComponent({component: BookingsComponent}))
    .service("addSelectCustomerDialogService", downgradeInjectable(AddSelectCustomerDialogService))
    .service("bookingsStateService", downgradeInjectable(BookingsStateService));

angular.module("dashboard")
    .directive("dashboard", downgradeComponent({component: DashboardComponent}))
    .service('dashboardReportGenerator', downgradeInjectable(DashboardReportGeneratorService))

angular.module("tables")
    .directive("tables", downgradeComponent({component: TablesComponent}))
    .directive("deliveryTakeAway", downgradeComponent({component: DeliveryTakeAwayComponent}))
    .factory("roomsStateService", downgradeInjectable(RoomsStateService));

angular.module("printersNew")
    .directive("generalSettings", downgradeComponent({component: GeneralSettingsComponent}))
    .directive("printerDetails", downgradeComponent({component: PrinterDetailsComponent}))
    .directive("newPrinter", downgradeComponent({component: NewPrinterComponent}))

angular.module("settingsNew")
    .directive("settingsUsersManagement", downgradeComponent({component: SettingsUsersManagementComponent}))
    .directive("settingsModelDocument", downgradeComponent({component: SettingsModelDocumentComponent}))
    .directive("settingsLabelPanel", downgradeComponent({component: SettingsLabelPanelComponent}))
    .directive("settingsShifts", downgradeComponent({component: SettingsShiftsComponent}))
    .directive("settingsChannels", downgradeComponent({component: SettingsChannelsComponent}))
    .directive("settingsUser", downgradeComponent({component: SettingsUserComponent}))
    .directive("settingsAlvolo", downgradeComponent({component: SettingsAlvoloComponent}))
    .directive("settingsKiosk", downgradeComponent({component: SettingsKioskComponent}))
    .directive("settingsTickets", downgradeComponent({component: SettingsTicketsComponent}))
    .directive("settingsPrintersModule", downgradeComponent({component: SettingsPrintersModuleComponent}))
    .directive("settingsHub", downgradeComponent({component: SettingsHubComponent}))

angular.module("core")
    .service("environmentInfo", downgradeInjectable(EnvironmentInfoService))
    .service("screenOrientation", downgradeInjectable(ScreenOrientationService))
    .service("oauth", downgradeInjectable(OauthService))
    .service("barcodeManager", downgradeInjectable(BarcodeManagerService))
    .service("connection", downgradeInjectable(ConnectionService))
    .service("coreState", downgradeInjectable(CoreStateService))
    .service("startupWatchdog", downgradeInjectable(StartupWatchdogService))
    .service("errorsLogger", downgradeInjectable(ErrorsLoggerService))
    .service("storageManager", downgradeInjectable(StorageManagerService))
    .service("shopSession", downgradeInjectable(ShopSessionEntity))
    .service("userSessions", downgradeInjectable(UserSessionsEntity))
    .service("loginView", downgradeInjectable(LoginViewService))
    .service("checkManager", downgradeInjectable(ConfigurationManagerService))
    .service("entityManager", downgradeInjectable(EntityManagerService))
    .service('OperatorManager', OperatorManagerService)
    .service("entityDictionariesStore", downgradeInjectable(EntityDictionariesStoreService))
    .service("startupQueries", downgradeInjectable(StartupQueriesService))
    .service("appToApp", downgradeInjectable(AppToAppService))
    .service('progressivesManager', downgradeInjectable(ProgressivesManagerService))
    .service('updateManager', downgradeInjectable(UpdateManagerService))
    .service('systemUtils', downgradeInjectable(SystemUtilsService))

angular.module("application")
    .factory("itemLabelsDialog", downgradeInjectable(ItemLabelsDialogService))
    .factory("signupFormDialog", downgradeInjectable(SignupFormDialogService))
    .service('editShopPreferenceDialogService', downgradeInjectable(EditShopPreferenceDialogService))
    .service('printerErrorFiscal', downgradeInjectable(PrinterErrorFiscalDialogService))
    .service('genericListDialog', downgradeInjectable(GenericListDialogService))
    .service('automateItemsDialogService', downgradeInjectable(AutomateItemsDialogService))
    .service('userSessionsManager', downgradeInjectable(UserSessionsManagerDialogService))
    .service('newPromptDialog', downgradeInjectable(PromptDialogService))
    .service('nonFiscalPreviewDialog', downgradeInjectable(NonFiscalPreviewDialogService))
    .service('addPaymentCondition', downgradeInjectable(AddEditPaymentConditionDialogService))
    .service('eInvoiceCredentialsDialogService', downgradeInjectable(EInvoiceCredentialsDialogService))
    .service('tilbyMessagesDialog', downgradeInjectable(ShowTilbyMessagesDialogService))
    .service('newConfirmDialog', downgradeInjectable(ConfirmDialogService))
    .service('newAlertDialog', downgradeInjectable(AlertDialogService))

angular.module("promotionsNew")
    .directive("promotionsShowcase", downgradeComponent({component: PromotionsShowcaseComponent}))
    .directive("promotionsDetails", downgradeComponent({component: PromotionsDetailsComponent}))

angular.module('digitalPayments')
    .service('AdyenPOS', downgradeInjectable(AdyenService))
    .service('satispay', downgradeInjectable(SatispayService))
    .service('zPMSConnector', downgradeInjectable(ZPMSConnectorService))
    .service("leanPMSPayments", downgradeInjectable(LeanPmsPaymentsDialogService))
    .service('GloryCashdrawer', downgradeInjectable(GloryCashdrawerService))
    .service('beddyApi', downgradeInjectable(BeddyApiService))
    .service('bedzzleCommon', downgradeInjectable(BedzzleCommonService))
    .service('bedzzleApi', downgradeInjectable(BedzzleApiService))
    .service('ericsoftPMSApi', downgradeInjectable(EricsoftPMSApiService))
    .service('leanPMSApi', downgradeInjectable(LeanPMSApiService))
    .service('spiaggeItApi', downgradeInjectable(SpiaggeItApiService))
    .service('ZPayBridge', downgradeInjectable(ZPayBridgeService))
    .service('ZPaySoftPOS', downgradeInjectable(ZPaySoftPOSService))
    .service('ZPay', downgradeInjectable(ZPayService))

angular.module('printers')
    .service('printerUtils', downgradeInjectable(PrinterUtilsService))
    .service('dailyClosingDialog', downgradeInjectable(DailyClosingDialogService))
    .service('DocumentBuilder', downgradeInjectable(DocumentBuilderService))
    .service('DitronDriver', downgradeInjectable(DitronDriverService))